import React from 'react';
import './MarqueeText.css';

const MarqueeText = () => {
    const marqueeContent = "Join us for our upcoming events and workshops!";
    
    const duplicatedContent = marqueeContent + " " + marqueeContent + " " + marqueeContent;

    return (
        <div className="marquee-container">
            <div className="marquee-content">
                <span>{duplicatedContent}</span>
            </div>
        </div>
    );
};

export default MarqueeText;
